import { render, staticRenderFns } from "./acts-editor-header.vue?vue&type=template&id=00efc5ae"
import script from "./acts-editor-header.vue?vue&type=script&lang=js"
export * from "./acts-editor-header.vue?vue&type=script&lang=js"
import style0 from "./acts-editor-header.vue?vue&type=style&index=0&id=00efc5ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports